var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.96 80.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #304a6f;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 4px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 40.48,
    cy: 40.48,
    r: 38.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.97,
    cy: 40.62,
    r: 8.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.61,
    y: 21.86,
    width: 2.73,
    height: 37.53,
    transform: "translate(-17 39.32) rotate(-44.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.61,
    y: 21.86,
    width: 2.73,
    height: 37.53,
    transform: "translate(41.28 -16.35) rotate(45.85)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.31,
    y: 20.65,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(.41 -.4) rotate(.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.31,
    y: 20.65,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(54.76 1) rotate(90.85)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.88,
    y: 21.06,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(.42 -.81) rotate(.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.88,
    y: 21.06,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(83.14 -26.14) rotate(90.85)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.93,
    y: 46.25,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(.79 -.39) rotate(.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.93,
    y: 46.25,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(79.97 27.36) rotate(90.85)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.49,
    y: 46.66,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(.8 -.8) rotate(.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.49,
    y: 46.66,
    width: 3.15,
    height: 13.65,
    rx: 1.52,
    ry: 1.52,
    transform: "translate(108.35 .21) rotate(90.85)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuad);
export default __webpack_public_path__ + "static/media/quad.4638addce1ea8f5adf4f9822d4da8da4.svg";
export { ForwardRef as ReactComponent };